import { ExpandLess, ExpandMore } from '@mui/icons-material'
import { Button, Card, CardContent, Collapse, Divider, Grid, Typography } from '@mui/material'
import { GreenText, LabelField } from 'components'
import { NeedsDriversLicensePhotoUploadedDetailsDto } from 'dtos/needsDriversLicensePhotoUploadedDetailsDto'
import { useState } from 'react'

interface OutboundTripNeedsDriversLicensePhotoUploadedHeroCardProps {
  outboundTrip: NeedsDriversLicensePhotoUploadedDetailsDto
}

export default function OutboundTripNeedsDriversLicensePhotoUploadedHeroCard({
  outboundTrip
}: OutboundTripNeedsDriversLicensePhotoUploadedHeroCardProps) {
  const [open, setOpen] = useState(false)

  const handleOpenClick = () => {
    setOpen(prev => !prev)
  }

  return (
    <Card>
      <CardContent>
        <Grid container spacing={1} alignItems='flex-start'>
          <Grid item xs={12} container wrap='nowrap' alignItems='center' justifyContent='space-between'>
            <Grid item xs={12} sm='auto' container alignItems='center' spacing={0}>
              <Grid item>
                <Typography fontWeight='bold' variant='h5' sx={{ pr: 1 }}>
                  Outbound Trip
                </Typography>
              </Grid>
            </Grid>

            <Grid item xs={12} sm='auto' container spacing={1}>
              <Grid item>
                <Button onClick={handleOpenClick}>{open ? <ExpandLess /> : <ExpandMore />}</Button>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12}>
            <Divider />
          </Grid>

          <Grid item xs={12}>
            <Collapse in={open} timeout='auto' unmountOnExit>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={3}>
                  <LabelField label='Outbound Trip #' value={outboundTrip.outboundTripNumber} />
                </Grid>

                <Grid item xs={12} sm={3}>
                  <LabelField label='Outbound Trip Date' value={outboundTrip.outboundTripDate} />
                </Grid>

                <Grid item xs={12} sm={3}>
                  <LabelField label='Outbound Transporter Company' value={outboundTrip.outboundTransporterCompany?.name} />
                </Grid>

                {/* <Grid item xs={12} sm={3}>
                  <LabelField label='Vehicles In Outbound Trip' value={outboundTrip.vehicles?.length} />
                </Grid> */}

                <Grid item xs={12} sm={3}>
                  <LabelField label='Internal Notes' value={outboundTrip.notes} />
                </Grid>

                <Grid item xs={12} sm={12}>
                  <GreenText variant='outlined'>
                    {`**Outbound Trip Information Card According:**

Clicking the Outbound Trip Information card will expanding the
according displaying additional details about the Outbound Trip

**Outbound Trip # Label:**

Displays the unique identifier of the Outbound Trip to which the
vehicle is assigned.

**Outbound Trip Date Label:**

Displays the scheduled date of the Outbound Trip.

**Outbound Transporter Company Label:**

Displays the company name for the Outbound Transporter
Company.

**Vehicles In Outbound Trip Label:**

Displays the total number of vehicles in the Outbound Trip.

**Internal Notes Label:**

Displays any entered notes internal notes for the Outbound Trip.

`}
                  </GreenText>
                </Grid>
              </Grid>
            </Collapse>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  )
}
